import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import "../css/products.css";
import ProductCard from "./ProductCard";

function FeaturedProducts() {

  const [products, setProducts] = useState([]);

  useEffect(() => {

   axios
  .get(`${API_URL}/featured-products`)
  .then((response) => {

    setProducts(response.data);

  })
 
      .catch((error) => {
        console.log(error);
      });

  }, []);

  return (

    <section className="products-section">

      <h2 className="section-title">
        ⭐ Featured Products
      </h2>

      <div className="products-grid">

        {products.length > 0 ? (

          products.map((product) => (

            <ProductCard
              key={product.id}
              product={product}
            />

          ))

        ) : (

          <h3>No Featured Products Found</h3>

        )}

      </div>

    </section>

  );

}

export default FeaturedProducts;